module.exports = __webpack_public_path__ + "86c9773812fc16a379a47cb1e4acf89c.svg";